@import "../../../globals/main.scss";

$animationTransitionTime: .8s;
$internationalAlternativeBlue: rgba(8, 58, 103, 1);

pn-hero-block-international {
  width: 100%;
}

.hero-international {
  width: 100%;
  min-height: unset;
  position: relative;
  background: $blue900;
  display: flex;

  @media screen and (min-width: $min-width-xl) {
    min-height: 44rem;
  }

  .hero-international__content {
    width: 100%;
    margin-bottom: 1.6rem;
    overflow-x: hidden;

    @media screen and (min-width: $min-width-xxl) {
      display: grid;
      grid-template-columns: 1fr $max-width-xxl 1fr;
    }

    .flex-wrapper {
      @include inner-container;
      grid-column: 2 / 3;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      display: flex;
      flex-direction: row;
      height: 100%;
      justify-content: space-between;

      @media screen and (min-width: $min-width-xxl) {
        justify-content: unset;
        padding: 0;
      }

      .content-col {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 4rem 0 4rem 0;

          @media screen and (min-width: $min-width-md) {
            min-width: 60.2rem;
          }

          @media screen and (min-width: $min-width-xxl) {
            min-width: 100.6rem;
            padding: 5rem 2rem 5rem 0;
          }
      }

      .hero-international__content__site-tag {
        display: block;
        color: $blue400;
        font-size: 1.6rem;

        @media screen and (min-width: $min-width-md) {
          font-size: 1.8rem
        }

        @media screen and (min-width: $min-width-xxl) {
          display: none;
        }
      }

      .hero-international__content__heading {
        color: $blue400;
        font-size: 3.2rem;
        font-weight: 500;
        line-height: 1.12;
        font-smooth: never;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-bottom: 1rem;

        span {
          margin-top: -0.3rem;
          display: block;
          color: white;
          font-weight: 700;
        }

        @media screen and (min-width: $min-width-md) {
          font-size: 4rem;
        }
        @media screen and (min-width: $min-width-lg) {
          font-size: 5.6rem;
          margin-bottom: 1.6rem;
        }
      }

      .hero-international__content__preamble {
          color: white;
          margin-bottom: 0;
          font-weight: 500;
          font-size: 1.6rem;

          @media screen and (min-width: $min-width-md) {
            font-size: 1.8rem
          }
          @media screen and (min-width: $min-width-xxl) {
            font-size: 2rem
          }
      }

      .hero-international__content__cta {
        margin-top: 2.4rem;

        @media screen and (min-width: $min-width-xxl) {
          margin-top: 3.2rem;
        }
      }

      .hero-international__content__logo-col {
        max-width: 60rem;
        display: none;

        @media screen and (min-width: $min-width-xxl) {
          max-width: unset;
          display: flex;
          width: 100%;
          flex-direction: column;
          justify-content: center;
        }

        .hero-international__content__logo-col__image {
          height: 32rem;

          svg {
            height: 100%;

            .cls-1 {
              fill:#083a67;
              stroke-width:0;
            }
            .svg-path-style1 {
              fill:#00a0d6;
              stroke-width:0;
            }
            .svg-path-style2 {
              fill:#fff;
              stroke-width:0;
            }
          }
        }
      }
    }
  }

  .hero-international__side-loader {
    grid-column: 3 / -1;
    display: none;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid transparent;
    padding-left: 8.8rem;

    @media screen and (min-width: $min-width-xxl) {
      display: flex;
    }

    .shape {
      background-color: $internationalAlternativeBlue;
      height: 32rem;
    }
  }

  .hero-international__side-loader--animate {
    transition: transform $animationTransitionTime ease-out;
    transform: translateX(100%);

    &.animate-in {
      transform: translateX(0);
    }
  }
}

.hero-international.hero-international--centered-layout {
  .hero-international__content .flex-wrapper {
    .hero-international__content__site-tag {
      display: block;
    }
  }

  .hero-international__content .flex-wrapper .content-col {
    @media screen and (min-width: $min-width-xl) {
      width: 100%;
      display: flex;
      align-items: center;
      padding-right: 0;
    }
  }

  .hero-international__content__heading {
    @media screen and (min-width: $min-width-xl) {
      text-align: center;
    }
  }
}

.hero-international.hero-international--animate {
  .hero-international__content__logo-col__image {
    transform: translateX(100%);
    transition: transform $animationTransitionTime - 0.3 ease-out;

    &.animate-in {
      transform: translateX(0);
    }
  }
}
